import { COMMON_PERMISSIONS } from '@/commons/permissoesGrupos';

export default [
    {
        path: '/inscricoes/cursos',
        name: 'listaCursos',
        component: () => import('@/modules/inscricoes/views/listas/CursosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/inscricoes/cursos/categorias',
        name: 'listaCursoCategorias',
        component: () => import('@/modules/inscricoes/views/listas/CursoCategoriasView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/inscricoes/cursos/novo',
        name: 'cadastroCurso',
        component: () => import('@/modules/inscricoes/views/cadastros/CadastroCursoView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/inscricoes/cursos/turmas/:id',
        name: 'detalheTurma',
        component: () => import('@/modules/inscricoes/views/detalhes/TurmaDetalheView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/inscricoes/cursos/turmas/:id/editar',
        name: 'editarTurma',
        component: () => import('@/modules/inscricoes/views/cadastros/CadastroTurmaView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/inscricoes/cursos/:cursoId/turmas/nova',
        name: 'cadastroTurma',
        component: () => import('@/modules/inscricoes/views/cadastros/CadastroTurmaView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/inscricoes/cursos/:id',
        name: 'detalheCurso',
        component: () => import('@/modules/inscricoes/views/detalhes/CursoDetalheView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/inscricoes/cursos/:id/editar',
        name: 'editarCurso',
        component: () => import('@/modules/inscricoes/views/cadastros/CadastroCursoView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
];
